import React, { useEffect, useMemo, useState } from 'react';

import { Title } from 'components/Misc/Typography';
import { Button, Datepicker, Currency, Input, Select } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Generator = ({ grade }) => {
	// Store data's data
	const [data, setData] = useState({
		price: '',
		sections: 9
	});

	// Use user's creation store
	const onGenerateStudentPayments = useUserCreateStore(state => state.onGenerateStudentPayments);

	// Handle grade payment generation
	const onGenerate = () => onGenerateStudentPayments(grade.id, data);

	// Handle data data change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Update price on grade collection
	useEffect(() => {
		if (!data.price) setData(prev => ({
			...prev,
			price: grade.price
		}));
	}, [grade.price]);

	return (
		<>
			<Title
				title="Maksājumu ģenerēšana"
			/>

			<div className="grid grid-cols-2 gap-4">
				<Currency
					name="price"
					label="Summa"
					value={data.price}
					onChange={onChange}
				/>

				<Select
					name="sections"
					label="Maksājumu skaits"
					placeholder=" "
					value={data.sections}
					onChange={onChange}
					options={[
						{ value: 1, name: '1. daļa' },
						{ value: 2, name: '2. daļas' },
						{ value: 9, name: '9. daļas' }
					]}
				/>

				<div className="col-span-2 flex justify-end">
					<Button
						icon="double_arrow"
						theme="success"
						value="Ģenerēt"
						onClick={onGenerate}
					/>
				</div>
			</div>
		</>
	);
};

export default Generator;